import { Page } from "@medentic/polaris-react";
import { SettingsPageWrapper } from "@shared/ui/Settings";
import { NotYetPlannedBanner as NotPlannedBanner } from "@shared/ui";
import { useParams } from "react-router-dom";
import { EntityType } from "@shared/types/commonTypes";

export default function SettingsInvoices() {
  const params = useParams<{ clinicId: string }>();
  const clinicId = params.clinicId;

  if (!clinicId) {
    return null;
  }
  return (
    <SettingsPageWrapper entityType={EntityType.CLINIC} entityId={clinicId}>
      <Page>
        <NotPlannedBanner />
      </Page>
    </SettingsPageWrapper>
  );
}
